import { Ionicons } from '@expo/vector-icons';

export interface Command {
	id: string;
	title: string;
	description: string;
	icon: keyof typeof Ionicons.glyphMap;
	action: (closeSearch?: () => void) => void;
	category: 'create' | 'navigate' | 'action';
	keywords?: string[];
	prefix?: string;
	inlineAction?: (args: string, closeSearch?: () => void) => void;
}

export interface CommandResult {
	type: 'command';
	command: Command;
}

export type CommandCategory = 'create' | 'navigate' | 'action';

export interface CommandRegistry {
	[category: string]: Command[];
}
